import React, { useState } from "react";
import { FlatList, StyleSheet, View } from "react-native";

import config from "../config/config";
import Screen from "../components/Screen";
import Icon from "../components/Icon";
import IconTouchable from "../components/IconTouchable";
import useUsers from "../hooks/useUsers";
import ListItem from "../components/lists/ListItem";
import AppText from "../components/AppText";
import ListItemTextInput from "../components/lists/ListItemTextInput";

function UsersScreen({ navigation }) {
    const { users } = useUsers();
    const [searchTerm, setSearchTerm] = useState();

    return (
        <Screen
            title={"Users"}
            navigation={navigation}
            rightIconComponent={
                <IconTouchable
                    name="account-plus"
                    onPress={() => {
                        navigation.navigate("NewUser");
                    }}
                />
            }
        >
            <FlatList
                data={
                    searchTerm
                        ? users.filter((user) => {
                              if (user.name.toUpperCase().indexOf(searchTerm.toUpperCase()) > -1) {
                                  return user;
                              }
                          })
                        : users
                }
                keyExtractor={(item) => item._id}
                ListHeaderComponent={
                    <View>
                        <View style={styles.totalsContainer}>
                            <AppText>Total Users</AppText>
                            <Icon name="account-multiple" backgroundColor={config.colors.white} iconColor={config.colors.tertiary} />
                            <AppText>{users.length}</AppText>
                        </View>
                        <ListItemTextInput
                            title="User Search"
                            onChange={(searchTerm) => {
                                setSearchTerm(searchTerm);
                            }}
                            autoFocus={true}
                        />
                    </View>
                }
                renderItem={({ item }) => (
                    <ListItem
                        title={item.name}
                        subTitle={item.email}
                        IconComponent={
                            <View>
                                {item.type == "admin" && <Icon name="account-star" backgroundColor={config.colors.red} />}
                                {item.type == "office" && <Icon name="desk" />}
                                {item.type == "yard" && <Icon name="crane" />}
                                {item.type == "driver" && <Icon name="car" />}
                                {item.type == "export" && <Icon name="export" />}
                            </View>
                        }
                        onPress={() => {
                            navigation.navigate("UserDetails", item);
                        }}
                        utilityComponent={<Icon name="arrow-right" backgroundColor={config.colors.white} iconColor={config.colors.tertiary} />}
                    />
                )}
            />
        </Screen>
    );
}

const styles = StyleSheet.create({
    totalsContainer: {
        justifyContent: "space-evenly",
        paddingTop: 10,
        backgroundColor: config.colors.white,
        flexDirection: "column",
        alignItems: "center",
    },
});

export default UsersScreen;
